import { useCallback, useEffect, useState } from 'react'
import { Ban, Globe, Plus } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { useToast } from '@/providers/UiProviders'
import { fetchBlockedCountries, blockCountry } from './mediaApi'

/**
 * TV — Davlatlarni bloklash (tz/mp3-tv). Davlat kodini kiritib bloklash =
 * o'sha davlatning barcha kanallari o'chiriladi (mijozlarга ko'rinmaydi).
 * Bekor qilish = qayta yoqadi.
 */
export function BlockedCountries() {
  const { toast } = useToast()
  const [blocked, setBlocked] = useState<string[]>([])
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)

  const load = useCallback(() => {
    void fetchBlockedCountries().then(setBlocked)
  }, [])

  useEffect(() => load(), [load])

  const apply = async (cc: string, block: boolean) => {
    if (!cc.trim()) return
    setBusy(true)
    try {
      const r = await blockCountry(cc.trim(), block)
      toast(block ? `Bloklandi (${r.affected})` : `Ochildi (${r.affected})`, { tone: 'success' })
      setCode('')
      load()
    } catch (e) {
      toast('Xatolik', { tone: 'error', ...(e instanceof Error && e.message ? { description: e.message } : {}) })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="p-6 w-full">
      <PageHeader title="ТВ — davlatlarni bloklash" screenId="TV.BLOCK" />
      <div className="mt-4 flex max-w-md items-end gap-2">
        <label className="flex flex-1 flex-col gap-1 text-sm">
          <span className="text-secondary">Davlat kodi (masalan RU, IR)</span>
          <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="RU" maxLength={2} />
        </label>
        <Button onClick={() => void apply(code, true)} disabled={busy || code.length !== 2}>
          <Ban size={14} /> Bloklash
        </Button>
      </div>

      <div className="mt-8 max-w-md">
        <div className="mb-2 flex items-center gap-2 text-sm font-medium text-secondary">
          <Globe size={14} /> Bloklangan davlatlar
        </div>
        {blocked.length === 0 ? (
          <div className="rounded-lg border border-divider p-4 text-sm text-tertiary">Bo'sh</div>
        ) : (
          <div className="flex flex-col gap-1">
            {blocked.map((cc) => (
              <div key={cc} className="flex items-center justify-between rounded-lg border border-divider px-3 py-2">
                <span className="font-mono font-medium text-primary">{cc}</span>
                <Button size="sm" variant="ghost" onClick={() => void apply(cc, false)} disabled={busy}>
                  <Plus size={13} /> Ochish
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
